import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { filtersAccordionStyles } from "@dana/Overrides/Widgets/ProductList/ProductListFiltersAccordion";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { AccordionSectionHeader } from "@insite/mobius/AccordionSection";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

filtersAccordionStyles.accordion = mergeToNew(filtersAccordionStyles.accordion, {
    mergeCss: true,
    css: css`
        padding-top: 0;
        ${AccordionSectionHeader} {
            button {
                background: ${themeColors.primary.white};
                margin-bottom: 8px;
                &,
                &:focus-visible,
                &:focus {
                    padding: 16px;
                    background: ${themeColors.primary.white};
                }

                &[aria-expanded="true"] {
                    background: ${themeColors.primary.white};
                    border-bottom: none;
                    border-top: 1px solid ${themeBackgrounds.lightGray};
                    margin-bottom: 0;
                }

                ${IconWrapper} {
                  &,
                  & svg {
                    width: 16px;
                    height: 16px;
                  }
                }

                &:hover {
                    background: ${themeColors.primary.white};
                    ${TypographyStyle} {
                        color: ${themeColors.primary.danaBlue};
                    }

                    ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.primary.danaBlue};
                            }
                        }
                    }
                }

                ${TypographyStyle} {
                    font-size: ${fontSizes.medium};
                    line-height: ${lineHeights.defaultLarge};
                    font-weight: ${fontWeights.semiBold};
                }
            }
        }

        ${AccordionSectionPanel} {
            background: ${themeColors.primary.white};
            padding: 16px;
            padding-top: 8px;
            border: 1px solid ${themeBackgrounds.lightGray};
            border-top: none;

            ${CheckboxGroupStyle} {
                padding: 0 8px;
            }

            &:not([hidden]) {
                margin-bottom: 8px;
                margin-top: -8px;
            }
        }
    `,
});
